import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { AnalysisService } from './services/analysis.service';
import { StatsComponent } from './stats/stats.component';
import { CostsComponent } from './costs/costs.component';
import { RecommendationsComponent } from './recommendations/recommendations.component';
import { InstallationCostComponent } from './installation-cost/installation-cost.component';
import { SavingsComponent } from './savings/savings.component';
import { SubvensionsComponent } from './subvensions/subvensions.component';
import { OffersComponent } from './offers/offers.component';
import { PricingService } from './services/pricing.service';
import { AgmCoreModule, PolygonManager, GoogleMapsAPIWrapper } from '@agm/core';
import { MapComponent } from './map/map.component';
import { InstallationcostService } from './services/installationcost.service';
import { PanelsService } from './services/panels.service';
import { RecommendationService } from './services/recommendation.service';
import { NguiMapModule } from '@ngui/map';
import {
  MatSliderModule, MatCardModule, MatToolbarModule, MatCheckboxModule,
  MatTabsModule, MatInputModule, MatIconModule, MatButtonModule
} from '@angular/material';
import 'hammerjs';
import { PlNumPipe } from './pipes/pl-num.pipe';
import { AngularFireModule } from 'angularfire2';
import { NgModule } from '@angular/core';
import * as firebase from 'firebase/app';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { SubvensionService } from 'app/services/subvension.service';
import { OfferService } from 'app/services/offer.service';
import { AppRoutingModule } from './/app-routing.module';
import { OffersEditorComponent } from './offers-editor/offers-editor.component';
import { SubvensionsEditorComponent } from './subvensions-editor/subvensions-editor.component';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthService } from 'app/services/auth.service';
import { AuthComponent } from './auth/auth.component';
import { ReportComponent } from './report/report.component';
import { ReportService } from 'app/services/report.service';
import { InfoComponent } from './info/info.component';
import { WojewodztwaService } from 'app/services/wojewodztwa.service';
import { NgxCarouselModule } from 'ngx-carousel';
import { MontagePriceService } from 'app/services/montage-price.service';
import { RegisterPageComponent } from './register-page/register-page.component';
import { NewOfferComponent } from './new-offer/new-offer.component';

export const firebaseConfig = {
  apiKey: 'AIzaSyCWoWi3EPjUG2eWyBUX9vmQrdfr2psUc3E',
  authDomain: 'solar-1d77e.firebaseapp.com',
  databaseURL: 'https://solar-1d77e.firebaseio.com',
  projectId: 'solar-1d77e',
  storageBucket: 'solar-1d77e.appspot.com',
  messagingSenderId: '722285668248'
};


@NgModule({
  declarations: [
    AppComponent,
    StatsComponent,
    CostsComponent,
    RecommendationsComponent,
    InstallationCostComponent,
    SavingsComponent,
    SubvensionsComponent,
    OffersComponent,
    MapComponent,
    PlNumPipe,
    OffersEditorComponent,
    SubvensionsEditorComponent,
    AuthComponent,
    ReportComponent,
    InfoComponent,
    RegisterPageComponent,
    NewOfferComponent
  ],
  imports: [
    BrowserModule, FormsModule,
    ReactiveFormsModule,
    NguiMapModule.forRoot({
      apiUrl: 'https://maps.google.com/maps/api/js?key=AIzaSyCTsyKaXIsMIMrtK7B2B6XpzUaoEY0h6UI&libraries=visualization,places,drawing'
    }),
    MatSliderModule, MatCardModule, MatToolbarModule, MatTabsModule, MatInputModule, BrowserAnimationsModule, MatButtonModule,
    MatIconModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AppRoutingModule,
    NgxCarouselModule,
    MatCheckboxModule
  ],
  exports: [MatButtonModule, MatCardModule, MatSliderModule,
    MatToolbarModule, MatTabsModule, MatInputModule, MatIconModule,
    BrowserAnimationsModule, MatCheckboxModule],
  providers: [AnalysisService, PolygonManager, GoogleMapsAPIWrapper,
    PricingService, RecommendationService, PanelsService,
    InstallationcostService, SubvensionService, OfferService, AuthService,
    ReportService, WojewodztwaService, MontagePriceService],
  bootstrap: [AppComponent]
})


export class AppModule { }



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/app.module.ts